export default __webpack_public_path__ + "static/media/expensive.6449ceef.jpg";